import React from 'react';

const PlanDetailsForm = ({ plan, setPlan, formErrors }) => {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label">
              Plan Date <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className={`form-control ${formErrors.planDate ? 'is-invalid' : ''}`}
              value={plan.planDate}
              onChange={(e) => setPlan({ ...plan, planDate: e.target.value })}
              required
            />
            {formErrors.planDate && (
              <div className="invalid-feedback">
                {formErrors.planDate}
              </div>
            )}
          </div>
          <div className="col-md-3">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={plan.status}
              onChange={(e) => setPlan({ ...plan, status: e.target.value })}
              required
            >
              <option value="Draft">Draft</option>
              <option value="Scheduled">Scheduled</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Bottling Date <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className={`form-control ${formErrors.bottlingDate ? 'is-invalid' : ''}`}
              value={plan.bottlingDate || ''}
              onChange={(e) => setPlan({ ...plan, bottlingDate: e.target.value })}
              required
            />
            {formErrors.bottlingDate && (
              <div className="invalid-feedback">
                {formErrors.bottlingDate}
              </div>
            )}
          </div>
          <div className="col-md-3">
            <label className="form-label">Performed By</label>
            <select
              className="form-control"
              value={plan.performedBy || ''}
              onChange={(e) => setPlan({ ...plan, performedBy: e.target.value })}
            >
              <option value="">Select...</option>
              <option value="In House">In House</option>
              <option value="VAZ">VAZ</option>
              <option value="MWL">MWL</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Notes</label>
          <textarea
            className="form-control"
            rows="3"
            value={plan.notes || ''}
            onChange={(e) => setPlan({ ...plan, notes: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};

export default PlanDetailsForm;